<template>
    <div class="checkout-radio">
        <input
            :id="id"
            v-model="localValue"
            type="radio"
            class="sr-only"
            :value="method.handle"
            name="shippingMethodHandle"
            required
        >

        <label :for="id" class="flex items-center p-2 bg-secondary-100 mb-2">
            <span class="checkout-radio__radio"></span>

            <span class="flex flex-1 items-center justify-between pr-4 text-sm">
                <span>{{ method.name }}</span>
                <span class="font-bold">{{ method.price }}</span>
            </span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,
            required: true,
        },
        method: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
        };
    },

    computed: {
        id() {
            return `shippingMethod-${this.method.id}`;
        },
        localValue: {
            get() {
                return this.modelValue;
            },
            set(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
    },
};
</script>
